import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Tag, TagGroup } from '@plone/components';
import { ArrowrightIcon } from '@plone/components/Icons';
import { ESSButton } from '../../Atoms/ESSButton';
import RichText from '../../Atoms/RichText';
import './TeaserCardHorizontal.scss';

/**
 * TeaserCardHorizontal: horizontal variant of the teaser card for listings.
 */
const TeaserCardHorizontal = ({
  title,
  description,
  imageUrl,
  url,
  label,
  readMoreText,
  border,
  className = '',
  isEditMode = false,
}) => {
  const intl = useIntl();
  const internalUrl = url ? flattenToAppURL(url) : null;

  const cardContent = (    
    <>
      <div className="teaser-card__media">
          {label && <div className="teaser-card__label">{label}</div>}
          {imageUrl && (
            <img
              src={flattenToAppURL(
                typeof imageUrl === 'string'
                  ? imageUrl
                  : imageUrl.download || imageUrl.url || '',
              )}
              alt={title || ''}
              loading="lazy"
            />
          )}
      </div>
      <div className="teaser-card__content">
        {title && (
          <h4 className="teaser-card__title">
            <RichText content={title}></RichText>
          </h4>
        )}
        {description && (
          <RichText
            className="teaser-card__description"
            content={description}
          />
        )}
        <ESSButton 
          variant="link-icon"
          className="teaser-card__readmore-link"
          href={internalUrl}>
          {readMoreText || 'Explore'}
          <ArrowrightIcon size="18px" />
        </ESSButton>
      </div>
    </>
  );

  return (
    <>
      {internalUrl ? (
        <UniversalLink 
          href={internalUrl} 
          className={`teaser-card teaser-card-horizontal ${className}`.trim()}
          style={{
            display: 'flex',
            flexFlow: 'row wrap',
            ...(border && { border: border }),
          }}
        > 
          {cardContent}
        </UniversalLink>
      ) : (
        <div 
          className={`teaser-card ${className}`.trim()}
          style={{
            ...(border && { border: border }),
          }}
        > 
          {cardContent}
        </div>
      )}
    </>
  );
};

TeaserCardHorizontal.propTypes = {
  title: PropTypes.string,
  imageUrl: PropTypes.string,
  url: PropTypes.string,
  label: PropTypes.string,
  readMoreText: PropTypes.string,
  border: PropTypes.string,
  className: PropTypes.string,
  isEditMode: PropTypes.bool,
};

TeaserCardHorizontal.defaultProps = {
  className: '',
  isEditMode: false,
  border: "var(--teasercardstandard-variantdefault-statedefault-border)",
};

export default TeaserCardHorizontal;
